const ColumnMaxMinWidthClasses = 'md:max-w-[284px] md:min-w-[108px]';

export default ColumnMaxMinWidthClasses;
